export default __webpack_public_path__ + "static/media/animation-arrow20.bafaffa7.gif";